import { Zap, Package, Flame, BadgeCheck, FileText } from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, text: "Exclusively for Licensed Pharmacies, Clinics & Hospitals" },
  { icon: Package, text: "10-BOX Wholesale Packs Available" },
  { icon: FileText, text: "GST Invoice on Every Order" },
  { icon: Zap, text: "DL + GST Verified Trade Ordering" },
  { icon: Flame, text: "Pharma Saver Sale is Live — Save up to 25%" },
];

function Strip() {
  return (
    <div className="flex items-center shrink-0">
      {[...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-2 px-6 text-emerald-100 text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap">
          <item.icon size={12} className="text-amber-400" />
          {item.text}
        </span>
      ))}
    </div>
  );
}

export default function AnnouncementBar() {
  return (
    <div className="fixed top-0 inset-x-0 z-[60] h-9 bg-emerald-900 overflow-hidden shadow-inner" data-testid="announcement-bar">
      <div className="animate-marquee flex h-9 items-center">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
